import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectCompanyIsLocked} from '../../../../data/company'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {ROUTE_COMPANY_PROFILE_DIRECTORS_BY_ID} from '../../../../routes/constants'
import {selectDirectors} from '../../../../data/directors'
import DeleteDirectorButton from '../../../../features/delete-director'
import {SECTION_DIRECTORS} from '../../../../constants/sections'

export const selectDirectorSummaryData = createSelector(
  selectDirectors,
  selectCompanyIsLocked,
  (state: Record<string, any>) => state,
  (directors, companyIsLocked, state) => {
    const isVerified =
      selectCombinedInputFieldStatusBySectionName(state, SECTION_DIRECTORS) ===
      FeInputFieldStatus.VERIFIED
    const summaryData = directors.map(director => {
      const name = `${director?.firstName} ${director?.lastName} `
      return {
        route: generatePath(ROUTE_COMPANY_PROFILE_DIRECTORS_BY_ID, {
          externalId: director?.externalId,
        }),
        name,
        position: director?.position || '',
        deleteButton: companyIsLocked || isVerified ? undefined : DeleteDirectorButton,
        deleteProps: {target: name, externalPersonId: director?.externalId},
      }
    })
    return summaryData
  }
)
